import { api } from "./NetworkBase";

export async function CreateOrder(newOrderModel) {
	let response = await api
		.post("ScannerApp/neworder", {
			json: newOrderModel,
		})
		.json();

	return JSON.parse(response);
}

export function GetSampleIdsForOrderSamples(order) {
	let samples = order.samples.map((sample) => {
		return sample.labId;
	});

	return samples;
}

export async function CreateBulkOrder(orders) {
	let response = await api
		.post("ScannerApp/bulk-orders", {
			json: orders,
		})
		.json();

	return response;
}


export async function CreateCompressorGuardBulkOrder(orders) {
	let response = await api
		.post("ScannerApp/compressor-guard-bulk-orders", {
			json: orders,
		})
		.json();

	return response;
}

